import { AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { BankDetailsService } from '../../../../core/services/bank/bank-details/bank-details.service'
import { MatInputModule } from '@angular/material/input'
import { BankService } from '../../../../core/services/bank/bank/bank.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { VehicleService } from '../../../../core/services/vehicle/vehicle/vehicle.service'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete'
import { Observable, of } from 'rxjs'
import { debounceTime, distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { NgxMaskConfig, NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { VehicleModelService } from '../../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleEditFormComponent } from "./vehicle-edit-form/vehicle-edit-form.component";
import { MatColumnDef, MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBar } from "@angular/material/progress-bar";
import { DocumentVehicleUpload, VehicleCreateModel } from '../../../../core/models/vehicle.model'

interface Supplier {
  id: number;
  razaoSocial: string;
  cnpj: string;
}



interface VehicleType {
  id: number
  modelo: string
}

@Component({
  selector: 'vehicle-edit',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatInputModule,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    MatColumnDef,
    VehicleEditFormComponent,
    MatIconModule,
    MatProgressBar,
    MatTableModule

  ],
  templateUrl: './vehicle-edit.component.html',
  styleUrl: './vehicle-edit.component.scss',
  providers: [VehicleService, provideNgxMask()],
  standalone: true,
})
export class VehicleEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private bankService: BankService,
    private snackbar: SnackbarCustomService,
    private vehicleService: VehicleService,
    private vehicleTypeService: VehicleTypeService,
    private supplierService: SupplierService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vehicleModelService: VehicleModelService,
    public dialogRef: MatDialogRef<VehicleEditComponent>
  ) { }

  @Output() responseCreate = new EventEmitter()

  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  filteredSuppliers: Observable<any[]> = of([]);
  filteredModelsVehicles: Observable<any[]> = of([]);
  listItems: Supplier[] = []
  AlllistTypeVehicles: any[] = []
  form: FormGroup = new FormGroup({})
  
  loading: boolean = false
  edit: any = false
  result: boolean = false
  plateExists = false
  dataItem: any = {}
  checkingPlate = false;
  itemsList: any[] = []
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    // {
    //   keyColumn: 'supplier',
    //   key: 'razaoSocial',
    //   description: 'Fornecedor',
    // },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'tipoDocDescricao',
      key: 'tipoDocDescricao',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'nomeArquivo',
      key: 'nomeArquivo',
      description: 'Documento',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: true },
      description: 'Ações',
    },
  ]
  displayedColumns: string[] = ['descricao', 'tipoDocDescricao', 'nomeArquivo', 'action']

  ngOnInit(): void {
    this.createForm()
    this.listSupplier()
    this.listAllTypeVehicles()
    this.fillForm()
     this.listDocuments()
    // this.form.get('active')?.disable()
    this.form.get('VehicleCode')?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      filter(plate => {
        // Só continua se a placa tiver exatamente 7 caracteres
        return plate && plate.length === 7;
      })
    ).subscribe(plate => {
      this.checkPlateAvailability(plate);
    });
  }



  private plateCache: { [key: string]: boolean } = {};

  private setupAutocomplete(): void {
    this.filteredSuppliers = this.form.get('supplier')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      startWith(''),
      map(value => this._filter(value))
    );
  }


  private TyperVehicleAutocomplete(): void {
    this.filteredModelsVehicles = this.form.get('TypeVehicle')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterTypeVehicles(value))
    )
  }


  private _filter(value: string | Supplier | null): Supplier[] {
    if (!value || typeof value !== 'string') {
      return this.listItems.slice();
    }

    const filterValue = value.toLowerCase();
    return this.listItems.filter(supplier =>
      supplier.razaoSocial.toLowerCase().includes(filterValue) ||
      supplier.cnpj.toLowerCase().includes(filterValue)
    );
  }



  private _filterTypeVehicles(value: string | VehicleType | null): VehicleType[] {
    if (!value || typeof value !== 'string') {
      return this.AlllistTypeVehicles.slice();
    }

    const filterValue = value.toLowerCase();
    return this.AlllistTypeVehicles.filter(model =>
      model.modelo.toLowerCase().includes(filterValue)
    );
  }


  displayFn(supplier: Supplier): string {
    if (!supplier) return ''
    return `${supplier.razaoSocial} - ${supplier.cnpj}`;
  }



  displayType(vehicle: VehicleType): string {
    if (!vehicle) return ''
    return vehicle.modelo;
  }


  private setTypeVehicleValue(): void {
    const typeVehicle = this.AlllistTypeVehicles.find(
      item => item.id === this.dataItem.veiculoModeloId
    );

    if (typeVehicle) {
      // Aqui está o importante - deve ser o objeto completo, não apenas a descrição
      this.form.get('TypeVehicle')?.setValue(typeVehicle);
    } else {
      console.warn('Tipo de veículo não encontrado para o ID:', this.dataItem.veiculoModeloId);
    }
  }

  private setSupplierValue(): void {
    const supplier = this.listItems.find(
      item => item.id === this.dataItem.fornecedorId
    );

    if (supplier) {
      // Aqui está o importante - deve ser o objeto completo, não apenas a descrição
      this.form.get('supplier')?.setValue(supplier);
    } else {
      console.warn('fornecedor não encontrado para o ID:', this.dataItem.fornecedorId);
    }
  }


  fillForm() {
    this.dataItem = this.data.item
    this.edit = this.data.frota

    this.form.get('active')?.setValue(this.dataItem.isFrota == 'S' ? true : false)
    this.form.get('active')?.disable()

    if (this.AlllistTypeVehicles && this.AlllistTypeVehicles.length > 0) {
      this.setTypeVehicleValue();
    } else {
      // Se a lista ainda não carregou, esperamos ela carregar
      this.vehicleModelService.listVehicleModel().subscribe({
        next: (res) => {
          this.AlllistTypeVehicles = res.data;
          this.TyperVehicleAutocomplete();
          this.setTypeVehicleValue();
        },
        error: (err) => {
          console.log('Error:', err);
        }
      });
    }

    if (this.edit == false) {
      if (this.listItems && this.listItems.length > 0) {
        this.setSupplierValue();
      } else {
        // Se a lista ainda não carregou, esperamos ela carregar
        this.supplierService.listSupplierLegal().subscribe({
          next: (res) => {
            this.listItems = res.data;
            this.setupAutocomplete();
            this.setSupplierValue();
          },
          error: (err) => {
            console.log('Error:', err);
          }
        });
      }
    }



    //  this.form.get('TypeVehicle')?.setValue(this.dataItem.tipoVeiculoId)
    this.form.get('VehicleCode')?.setValue(this.dataItem.placa)



    if (this.form.get('active')?.value == true) {
      this.form.get('supplier')?.disable()
    } else {
      this.form.get('supplier')?.enable()
    }
  }

  formatCNPJ(cnpj: string): string {
    // Formatação básica de CNPJ: 00.000.000/0000-00
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }

  listAllTypeVehicles() {
    this.vehicleModelService.listVehicleModel().subscribe({

      next: (res) => {

        this.AlllistTypeVehicles = res.data
        this.TyperVehicleAutocomplete()
      },
      error: (err) => {
        console.log('Error:', err)
      }
    })
  }


  checkPlateAvailability(plate: string): void {
    this.plateExists = false
    // Verifica se a placa está vazia ou incompleta
    if (!plate || plate.length < 7) {
      this.plateExists = false;
      this.checkingPlate = false;
      return;
    }

    // Verifica se já temos essa placa no cache
    if (this.plateCache.hasOwnProperty(plate)) {
      this.plateExists = this.plateCache[plate];
      this.checkingPlate = false;
      return;
    }

    this.checkingPlate = true;
    this.vehicleService.getVehicleModelbyPlate(plate).subscribe({
      next: (res) => {
        this.plateExists = res.statusCode === 200;
        this.plateCache[plate] = this.plateExists;
        this.checkingPlate = false;
      },
      error: (err) => {
        this.plateExists = false;
        this.checkingPlate = false;
        console.error('Erro ao verificar placa:', err);
      }
    });
  }




  // searchVehicleCode(placa: string) {
  //   this.vehicleService.getVehicleModelbyPlate(this.form.get('VehicleCode')?.value).subscribe({

  //     next: (res) => {
  //       if (res.statusCode == 200) {
  //         this.result = true
  //       } else {
  //         this.result = false
  //       }
  //     },
  //     error: (err: ErrorRequestModel) => {
  //       this.snackbar.errorRequest(err)
  //     }
  //   })
  // }


  editItem() {
    // this.searchVehicleCode(this.form.get('VehicleCode')?.value.placa)
    // if (this.result == false) {
    this.loading = true
    const model = this.createModel()
    this.vehicleService.editVehicleModel(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        // this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.createForm()
      },
    })
    // } else {
    //   this.snackbar.error('Placa ja cadastrada')
    // }
  }

  listSupplier() {

    this.supplierService.listSupplierLegal().subscribe({
      next: (res) => {
        this.listItems = res.data
        this.setupAutocomplete()
        // this.setupAutocomplete();

      },
      error: () => {
        console.error('Ocorreu um erro ao listar os fornecedores')
      }
    })
  }


  createModel() {
    return {
      id: this.data.item.id,
      placa: this.form.controls['VehicleCode'].value.toUpperCase(),
      veiculoModeloId: this.form.controls['TypeVehicle'].value.id,
      fornecedorId: this.data.frota === true ? null : this.form.get('supplier')?.value?.id || null,
      isFrota: this.form.get('active')?.value == true ? 'S' : 'N',
    };
  }

  createModelDoc(element: any){
    const model = new DocumentVehicleUpload()
    model.document = {
      veiculoId: element.veiculoId,
      descricao: element.descricao,
      tipoDocId: element.tipoDocId.id,
      arquivo: element.arquivo
    }
    return model.toFormData()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      VehicleCode: [null, [Validators.required]],
      TypeVehicle: ['', [Validators.required]],
      supplier: [null],
      active: [false],
    })
  }

  

  close() {
    this.dialogRef.close({ success: true })
  }

  deleteItem(element: any) {
    this.loading = true
    this.vehicleService.deleteVehicleDocumentbyId(element.id).subscribe({
      next: (res) =>{
        this.snackbar.success(res.message)
        this.listDocuments()
        this.loading = false
      }, 
      error(err) {
        console.log(err)
      }
    })
  }

  addItem(response: any) {
    

    this.vehicleService.uploadVehicleDocumentby(this.createModelDoc(response)).subscribe({
      next: (res) =>{
        this.snackbar.success(res.message)
        this.listDocuments()
      },
      error(err) {
        console.log(err)
      }
    })
  }

  listDocuments() {
    this.loading = true
    this.vehicleService.getVehicleDocumentbyId(this.data.item.id).subscribe({
      next: (res) => {
        this.itemsList = res.data
        this.tableSource = new MatTableDataSource<any>(this.itemsList)
        this.loading = false
      },
      error: (err) => {
        console.log('Error:', err)
      }
    })
  }
}
